export const getStore = () =>
  typeof window !== 'undefined' && window.$nuxt?.$store;
